import React from "react";

const Banner = () => {
  return (
    <div
      className="relative w-full h-[400px] md:h-[500px] overflow-hidden"
      style={{
  backgroundImage: "url('/images/banner.webp')",
          backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/55"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <h1 className="text-white text-4xl md:text-6xl font-bold leading-tight">
          We Are Here To Help You
        </h1>

        <h2 className="mt-6 text-3xl md:text-5xl font-bold">
          <span className="text-white">Call Us:</span>{" "}
          <span className="text-orange-500">+91 8884742478</span>{" "}
                    <span className="text-orange-500">+91 8884744258</span>

        </h2>
      </div>
    </div>
  );
};

export default Banner;